/* Built In Imports */
import { usePathname } from 'next/navigation';

/* External Imports */
import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import StructuredTextContent from '@components/UI/StructuredTextContent';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';

/* Services */
import { searchByFieldId } from '@components/Utility/Shared/SharedService';

/**
 * Returns the Top Banner Event .
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Content from API
 * @param {string} region - Region of page
 * @param {string} language - Lang of page
 * @returns {ReactElement} TopBannerEvent component
 */

const TopBannerEvent = ({
  sectionContent,
  sectionContent2,
  region,
  language,
  section,
}) => {
  const pathName = usePathname();

  const styles = {
    default: 'polygon(0 0, 100% 0, 100% 100%, 0 85%)',
    'without-bottom-angle': '',
    '': 'polygon(0 0, 100% 0, 100% 100%, 0 85%)',
  };

  const gtmClick = () => {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'EoE_Interested',
    });

    // dataLayer.push({ ecommerce: null });
    // dataLayer.push({
    //   event: 'view_item',
    //   ecommerce: {
    //     currency: '',
    //     value: '',
    //     items: [
    //       {
    //         item_id: city, // id of the program
    //         item_name: 'EoE', // Name of the program (Ex - EoE)
    //         affiliation: '',
    //         coupon: '',
    //         discount: '',
    //         index: '',
    //         item_brand: isIeDone ? 'Yes' : 'No', //IE Status <Yes/No>
    //         item_category: ieLang, //IE Lang (User selected IE Language Ex- MR,EN,HI)
    //         item_category2: '',
    //         item_category3: '',
    //         item_category4: 'Top_CTA',
    //         item_category5: '',
    //         item_list_id: '',
    //         item_list_name: '',
    //         item_variant: '',
    //         location_id: cityName,
    //         price: '',
    //         quantity: '',
    //       },
    //     ],
    //   },
    // });
  };

  const isRestOfLocales =
    region !== 'us' && region !== 'uk' && region !== 'ca' && region !== 'in';

  return (
    <Box h={{ base: '100%', md: 'auto' }}>
      <Box height={'auto'} w={'100%'}>
        <Box
          alignItems={'center'}
          display="flex"
          justifyContent="flex-end"
          h={{
            base: 'auto',
            sm: 'auto',
            xl: '500px',
          }}
          minH={{
            base: '490px',
            sm: '800px',
            xl: '600px',
          }}
          backgroundRepeat="no-repeat"
          backgroundSize={{ base: 'contain', xl: 'cover' }}
          backgroundPosition={{ base: 'top', lg: 'top' }}
          backgroundImage={{
            base:
              sectionContent?.mobileImage?.url ||
              sectionContent?.desktopImage?.url,
            xl: sectionContent?.desktopImage?.url,
          }}
          bgColor="#211637"
          mb={{ base: '0', xl: '0' }}
          clipPath={styles[sectionContent.style]}
          pr={{ base: '0', xl: '50px' }}
        >
          <Flex
            textAlign="center"
            flexDirection="column"
            verticalAlign={'center'}
            m={{ base: '60% 0 0 0', xl: '0 0 0 5%' }}
            p={{ base: '35px 0 0 0', xl: '0' }}
            w={{ base: '100%', sm: '100%', xl: '50%' }}
            maxW={{
              base: 'auto',
              xl: '40%',
            }}
            fontSize={{
              sm: '44px',
              base: '30px',
            }}
            color="#fff"
            fontFamily="FedraSansStd-medium"
            bgColor={{ base: '#211637', xl: 'transparent' }}
            clipPath={{
              base: `polygon(0 6%, 100% 0, 100% 100%, 0% 100%)`,
              lg: 'initial',
            }}
          >
            <Flex justifyContent="center">
              <LazyLoadImageComponent
                maxW={{ base: '50%', lg: 'auto' }}
                minH={{ base: 'auto', lg: 'auto' }}
                src={sectionContent2?.image?.url}
                alt={sectionContent2?.image?.alt}
                title={sectionContent2?.image?.title}
              />
            </Flex>

            {isRestOfLocales &&
              searchByFieldId(section?.sectionContent, 'rest-dates') &&
              render(
                searchByFieldId(section?.sectionContent, 'rest-dates').body
              ) !== '<p></p>' && (
                <Box
                  fontSize={{
                    base: '20px',
                    md: '24px',
                  }}
                  fontFamily="FedraSansStd-medium"
                  color="#fff"
                  mt="20px"
                >
                  {StructuredTextContent(
                    searchByFieldId(section?.sectionContent, 'rest-dates').body
                  )}
                </Box>
              )}

            {!isRestOfLocales &&
              render(sectionContent?.date) &&
              render(sectionContent?.date) !== '<p></p>' && (
                <Box
                  fontSize={{
                    base: '20px',
                    md: '24px',
                  }}
                  fontFamily="FedraSansStd-medium"
                  color="#fff"
                  mt="20px"
                >
                  {StructuredTextContent(sectionContent.date)}
                </Box>
              )}

            {render(sectionContent?.bottomText) &&
              render(sectionContent?.bottomText) !== '<p></p>' && (
                <Box
                  id="donate-button"
                  fontSize={{
                    base: '14px',
                    md: '20px',
                  }}
                  fontFamily="FedraSansStd-medium"
                  mb="10px"
                  mt="10px"
                  lineHeight="160%"
                >
                  {StructuredTextContent(sectionContent.bottomText)}
                </Box>
              )}
             {/* Registration is closed */}            
             {render(sectionContent?.closedMessage) &&
                render(sectionContent?.closedMessage) !== '<p></p>' && (
                <Box
                  fontSize={{ base: '16px', md: '20px' }}
                  fontFamily="FedraSansStd-book"
                  color="#90816E"
                  mt="10px"
                >
                  {StructuredTextContent(sectionContent.closedMessage)}
                </Box>
            )}
            {/* Banner button register */}
            {sectionContent?.button?.length > 0 && (
              <>
                {/* {!pathName?.endsWith('-toronto') && (
                  <Box mx="auto" w="80%" maxW="250px">
                    <Link
                      href={refineUrlDomain(
                        sectionContent?.button[0]?.linkUrl,
                        region,
                        language
                      )}
                      // bg="#FBAD2E"
                      fontFamily="FedraSansStd-book"
                      color="#211637"
                      fontSize={{ base: '18px', md: '20px' }}
                      _hover={{ textDecor: 'none' }}
                      display="flex"
                      flexDir="column"
                      border="0px"
                      p="0"
                      h="100%"
                      mt="30px"
                      mb={{ base: '30px', md: '10px' }}
                      alignItems={'center'}
                      w="246px"
                      onClick={() => {
                        gtmClick();
                      }}
                    >
                      {sectionContent?.description != '' && (
                        <Box
                          backgroundSize={{ base: 'contain', md: 'contain' }}
                          width="100%"
                          bg="#EFEFEF"
                          borderRadius="5px 5px 0 0"
                          py="10px"
                        >
                          <Text
                            // bg="#fff"
                            color="#F37021"
                            fontFamily="FedraSansStd-book"
                            fontSize={{ base: '14px', md: '16px' }}
                            borderRadius="5px 5px 0px 0px"
                            // py="8px"
                            p={{ base: '0', md: '1px 27px 1px 12px' }}
                            w="full"
                            fontWeight="600"
                            textDecor={'none'}
                            _hover={{ textDecor: 'none' }}
                            className="earlybird"
                          >
                            {StructuredTextContent(sectionContent?.description)}
                          </Text>
                        </Box>
                      )}
                      <Text
                        borderRadius={'0 0 5px 5px'}
                        // textTransform="uppercase"
                        fontFamily="FedraSansStd-medium"
                        py={{ base: '14px', md: '14px' }}
                        px="40px"
                        fontWeight="normal"
                        fontSize={{ base: '18px', md: '20px' }}
                        bg="#FBAD2E"
                        w="full"
                      >
                        {sectionContent?.button[0]?.buttonText}
                      </Text>
                    </Link>
                  </Box>
                )} */}
                {/* {pathName?.endsWith('-toronto') && ( */}
                  <Box mx="auto" w="80%" maxW="250px">
                    <Link
                      href={refineUrlDomain(
                        sectionContent?.button[0]?.linkUrl,
                        region,
                        language
                      )}
                      // bg="#FBAD2E"
                      fontFamily="FedraSansStd-book"
                      color="#211637"
                      fontSize={{ base: '18px', md: '20px' }}
                      _hover={{ textDecor: 'none' }}
                      display="flex"
                      flexDir="column"
                      border="0px"
                      p="0"
                      h="100%"
                      mt="30px"
                      mb={{ base: '30px', md: '10px' }}
                      alignItems={'center'}
                      w="275px"
                      onClick={() => {
                        gtmClick();
                      }}
                    >
                      {sectionContent?.description?.value?.document?.children[0]?.children[0]?.value != '' && (
                        <Box
                          background={{
                            base: `url(${config.imgPath}/d/46272/1701337629-early_bird_ribbon_banner.png) no-repeat`,
                            md: `url(${config.imgPath}/d/46272/1701337629-early_bird_ribbon_banner.png) no-repeat`,
                          }}
                          backgroundSize={{ base: 'contain', md: 'cover' }}
                          color="#fff"
                          w={{ base: '100%', md: '100%' }}
                          pt={{ base: '0', md: '2px' }}
                          pb={{ base: '25px', md: '18px' }}
                          borderRadius={{ base: '5px', md: '5px' }}
                          backgroundPosition="bottom"
                        >
                          <Text
                            color="#fff"
                            fontFamily="FedraSansStd-book"
                            fontSize={{ base: '14px', md: '16px' }}
                            borderRadius="5px 5px 0px 0px"
                            // py="8px"
                            p={{ base: '0', md: '1px 27px 1px 12px' }}
                            w="full"
                            fontWeight="600"
                            textDecor={'none'}
                            _hover={{ textDecor: 'none' }}
                            className="earlybird"
                          >
                            {StructuredTextContent(sectionContent?.description)}
                          </Text>
                        </Box>
                      )}
                      <Text
                        borderRadius={'5px'}
                        // textTransform="uppercase"
                        fontFamily="FedraSansStd-medium"
                        py={{ base: '14px', md: '14px' }}
                        px="40px"
                        fontWeight="normal"
                        fontSize={{ base: '18px', md: '20px' }}
                        bg="#FBAD2E"
                        w="full"
                      >
                        {sectionContent?.button[0]?.buttonText}
                      </Text>
                    </Link>
                  </Box>
                {/* )} */}
              </>
            )}
          </Flex>
        </Box>
      </Box>
      <style global jsx>{`
        .earlybird p mark {
          font-family: FedraSansStd-medium;
          color: #fff;
          background: transparent;
        }
      `}</style>
    </Box>
  );
};

export default TopBannerEvent;
